import { createFileRoute } from '@tanstack/react-router';

import { HomePreview } from '#modules/user/features/dashboard/components/HomePreview';

/**
 * Временный экран для сравнения раскладок Home. Живёт отдельно от /dashboard, чтобы ничего
 * не ломать, и удаляется вместе с компонентом одним движением.
 *
 * `ssr: false` по той же причине, что у друзей: содержимое личное и между визитами меняется,
 * серверный рендер его не переиспользует.
 *
 * Параметры адреса: сюда ведёт Discord DM о совпадении. `propose` это автор совпавшей заявки,
 * `post` сама заявка; с ними экран открывает карточку хода уже заполненной. Мусор в адресе
 * молча отбрасывается, чужая ссылка не должна показывать пустой экран.
 */
const uuid = (value: unknown) =>
  typeof value === 'string' && /^[0-9a-f-]{36}$/i.test(value) ? value : undefined;

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/_authed/preview')({
  component: HomePreview,
  validateSearch: (search: Record<string, unknown>): { propose?: string; post?: string } => ({
    propose: uuid(search.propose),
    post: uuid(search.post),
  }),
  ssr: false,
});
